import { createSlice } from '@reduxjs/toolkit';

const vehicleSlice = createSlice({
  name: 'vehicle',
  initialState: {
    addVehicleData: {},
    addVehicleDataIsLoading: false,
    addVehicleDataErrorMsg: null,

    getVehicleTypeListData: [],
    getVehicleListTypeDataIsLoading: false,
    getVehicleListTypeDataErrorMsg: null,

    getBrandsByVehicleData: [],
    getBrandsByVehicleDataIsLoading: false,
    getBrandsByVehicleDataErrorMsg: null,

    getModalByBrandData: [],
    getModalByBrandDataIsLoading: false,
    getModalByBrandDataErrorMsg: null,

    vehicleRegistrationData: {},
    vehicleRegistrationDataIsLoading: false,
    vehicleRegistrationDataErrorMsg: null,

    editVehicleData: {},
    editVehicleDataIsLoading: false,
    editVehicleDataErrorMsg: null,

    vehicleSubTypeData: [],
    vehicleSubTypeDataIsLoading: false,
    vehicleSubTypeDataErrorMsg: null,

    ratepredictorData: [],
    ratepredictorDataIsLoading: false,
    ratepredictorDataErrorMsg: null,
  },
  reducers: {
    // Add Vehicle
    addVehicleReq: (state, action) => { },
    addVehicleSuccess: (state, action) => ({
      ...state,
      addVehicleData: action.payload,
      addVehicleDataIsLoading: false,
      addVehicleDataErrorMsg: null,
    }),
    addVehicleFailure: (state, action) => ({
      ...state,
      addVehicleDataIsLoading: false,
      addVehicleDataErrorMsg: action.payload,
    }),
    addVehicleLoading: (state) => ({
      ...state,
      addVehicleDataIsLoading: true,
      addVehicleDataErrorMsg: null,
    }),
    addVehicleClear: (state) => ({
      ...state,
      addVehicleData: {},
      addVehicleDataIsLoading: false,
      addVehicleDataErrorMsg: null,
    }),

    // Get Vehicle Type
    getVehicleTypeReq: (state, action) => { },
    getVehicleTypeSuccess: (state, action) => ({
      ...state,
      getVehicleListTypeData: action.payload,
      getVehicleListTypeDataIsLoading: false,
      getVehicleListTypeDataErrorMsg: null,
    }),
    getVehicleTypeFailure: (state, action) => ({
      ...state,
      getVehicleListTypeDataIsLoading: false,
      getVehicleListTypeDataErrorMsg: action.payload,
    }),
    getVehicleTypeLoading: (state) => ({
      ...state,
      getVehicleListTypeDataIsLoading: true,
      getVehicleListTypeDataErrorMsg: null,
    }),
    getVehicleTypeClear: (state) => ({
      ...state,
      getVehicleListTypeData: [],
      getVehicleListTypeDataIsLoading: false,
      getVehicleListTypeDataErrorMsg: null,
    }),

    // Get Brands by Vehicle
    getBrandsByVehicleReq: (state, action) => { },
    getBrandsByVehicleSuccess: (state, action) => ({
      ...state,
      getBrandsByVehicleData: action.payload,
      getBrandsByVehicleDataIsLoading: false,
      getBrandsByVehicleDataErrorMsg: null,
    }),
    getBrandsByVehicleFailure: (state, action) => ({
      ...state,
      getBrandsByVehicleDataIsLoading: false,
      getBrandsByVehicleDataErrorMsg: action.payload,
    }),
    getBrandsByVehicleLoading: (state) => ({
      ...state,
      getBrandsByVehicleDataIsLoading: true,
      getBrandsByVehicleDataErrorMsg: null,
    }),
    getBrandsByVehicleClear: (state) => ({
      ...state,
      getBrandsByVehicleData: [],
      getBrandsByVehicleDataIsLoading: false,
      getBrandsByVehicleDataErrorMsg: null,
    }),

    // Get Modal by Brand
    getModalByBrandReq: (state, action) => { },
    getModalByBrandSuccess: (state, action) => ({
      ...state,
      getModalByBrandData: action.payload,
      getModalByBrandDataIsLoading: false,
      getModalByBrandDataErrorMsg: null,
    }),
    getModalByBrandFailure: (state, action) => ({
      ...state,
      getModalByBrandDataIsLoading: false,
      getModalByBrandDataErrorMsg: action.payload,
    }),
    getModalByBrandLoading: (state) => ({
      ...state,
      getModalByBrandDataIsLoading: true,
      getModalByBrandDataErrorMsg: null,
    }),
    getModalByBrandClear: (state) => ({
      ...state,
      getModalByBrandData: [],
      getModalByBrandDataIsLoading: false,
      getModalByBrandDataErrorMsg: null,
    }),

    // Vehicle Registration
    vehicleRegistrationReq: (state, action) => { },
    vehicleRegistrationSuccess: (state, action) => ({
      ...state,
      vehicleRegistrationData: action.payload,
      vehicleRegistrationDataIsLoading: false,
      vehicleRegistrationDataErrorMsg: null,
    }),
    vehicleRegistrationFailure: (state, action) => ({
      ...state,
      vehicleRegistrationDataIsLoading: false,
      vehicleRegistrationDataErrorMsg: action.payload,
    }),
    vehicleRegistrationLoading: (state) => ({
      ...state,
      vehicleRegistrationDataIsLoading: true,
      vehicleRegistrationDataErrorMsg: null,
    }),
    vehicleRegistrationClear: (state) => ({
      ...state,
      vehicleRegistrationData: {},
      vehicleRegistrationDataIsLoading: false,
      vehicleRegistrationDataErrorMsg: null,
    }),

    // Edit Vehicle
    editVehicleReq: (state, action) => { },
    editVehicleSuccess: (state, action) => ({
      ...state,
      editVehicleData: action.payload,
      editVehicleDataIsLoading: false,
      editVehicleDataErrorMsg: null,
    }),
    editVehicleFailure: (state, action) => ({
      ...state,
      editVehicleDataIsLoading: false,
      editVehicleDataErrorMsg: action.payload,
    }),
    editVehicleLoading: (state) => ({
      ...state,
      editVehicleDataIsLoading: true,
      editVehicleDataErrorMsg: null,
    }),
    editVehicleClear: (state) => ({
      ...state,
      editVehicleData: {},
      editVehicleDataIsLoading: false,
      editVehicleDataErrorMsg: null,
    }),

    // Vehicle Sub Type
    vehicleSubTypeReq: (state, action) => { },
    vehicleSubTypeSuccess: (state, action) => ({
      ...state,
      vehicleSubTypeData: action.payload,
      vehicleSubTypeDataIsLoading: false,
      vehicleSubTypeDataErrorMsg: null,
    }),
    vehicleSubTypeFailure: (state, action) => ({
      ...state,
      vehicleSubTypeDataIsLoading: false,
      vehicleSubTypeDataErrorMsg: action.payload,
    }),
    vehicleSubTypeLoading: (state) => ({
      ...state,
      vehicleSubTypeDataIsLoading: true,
      vehicleSubTypeDataErrorMsg: null,
    }),
    vehicleSubTypeClear: (state) => ({
      ...state,
      vehicleSubTypeData: [],
      vehicleSubTypeDataIsLoading: false,
      vehicleSubTypeDataErrorMsg: null,
    }),

    // Rate Predictor
    RatePredictorReq: (state, action) => { },
    RatePredictorSuccess: (state, action) => ({
      ...state,
      ratepredictorData: action.payload,
      ratepredictorDataIsLoading: false,
      ratepredictorDataErrorMsg: null,
    }),
    RatePredictorFailure: (state, action) => ({
      ...state,
      ratepredictorDataIsLoading: false,
      ratepredictorDataErrorMsg: action.payload,
    }),
    RatePredictorLoading: (state) => ({
      ...state,
      ratepredictorDataIsLoading: true,
      ratepredictorDataErrorMsg: null,
    }),
    RatePredictorClear: (state) => ({
      ...state,
      ratepredictorData: [],
      ratepredictorDataIsLoading: false,
      ratepredictorDataErrorMsg: null,
    }),
  },
});

export const {
  addVehicleClear,
  addVehicleFailure,
  addVehicleLoading,
  addVehicleReq,
  addVehicleSuccess,

  getVehicleTypeClear,
  getVehicleTypeFailure,
  getVehicleTypeLoading,
  getVehicleTypeReq,
  getVehicleTypeSuccess,

  getBrandsByVehicleClear,
  getBrandsByVehicleFailure,
  getBrandsByVehicleLoading,
  getBrandsByVehicleReq,
  getBrandsByVehicleSuccess,

  getModalByBrandClear,
  getModalByBrandFailure,
  getModalByBrandLoading,
  getModalByBrandReq,
  getModalByBrandSuccess,

  vehicleRegistrationClear,
  vehicleRegistrationFailure,
  vehicleRegistrationLoading,
  vehicleRegistrationReq,
  vehicleRegistrationSuccess,

  editVehicleClear,
  editVehicleFailure,
  editVehicleLoading,
  editVehicleReq,
  editVehicleSuccess,

  vehicleSubTypeClear,
  vehicleSubTypeFailure,
  vehicleSubTypeLoading,
  vehicleSubTypeReq,
  vehicleSubTypeSuccess,

  RatePredictorClear,
  RatePredictorFailure,
  RatePredictorLoading,
  RatePredictorReq,
  RatePredictorSuccess,
} = vehicleSlice.actions;

export default vehicleSlice.reducer;
